'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import throttle from 'lodash.throttle';

/**
 * 高阶组件，提供`sticky`功能
 * 针对浏览器端和安卓设备上scroll事件连续触发:
 *  lodash.throttle(func, 50) // https://lodash.com/docs#throttle
 *  setTimeout(func, 0) // 计算元素的layout属性将引起reflow, 异步处理
 *  window.requestAnimationFrame(func) // 平滑性更好
 * @param {*} WrappedComponent 
 */

/**
 * TODO: 
 * iOS sticky css优化（不支持callback）
 * 指定父容器
 * 滚动吸底
 */

export const StickyDecorator = WrappedComponent => class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        // 默认吸顶
        if (props.bottomOffset !== undefined) {
            this.bottomSticky = true
        } else {
            this.topSticky = true
        }
    }
    componentWillMount() {
        // 默认监听容器`window`
        const { scrollContainer = window, setSticky } = this.props
        scrollContainer.addEventListener('touchmove', this._scrollHandler = throttle(this.scrollHandle.bind(this), 50));
        this.scrollContainer = scrollContainer;
        setSticky && this._triggerHandler(setSticky);
    }
    componentDidMount() {
        setTimeout(() => {
            if (!this.content) return
            const { left, right, width, height } = this.content.getBoundingClientRect()
            this.setState({
                originWidth: width,
                originHeight: height,
                originFromLeft: left,
                originFromRight: right
            })
        }, 0)
    }
    componentDidUpdate() {
        this.placeholder.style.paddingBottom = `${this.state.isSticky ? this.state.originHeight : 0}px`;
    }
    componentWillReceiveProps(nextProps) {
        let { setSticky } = nextProps
        if (setSticky === undefined || setSticky === this.state.isSticky) return
        if (!this.state.originHeight) {
            // 说明：初始化时不可见
            const { left, right, width, height } = this.content.getBoundingClientRect()
            this.setState({
                originWidth: width,
                originHeight: height,
                originFromLeft: left,
                originFromRight: right
            });
        }
        this._triggerHandler(setSticky)
    }
    componentWillUnmount() {
        this.scrollContainer.removeEventListener('touchmove', this._scrollHandler);
    }
    scrollHandle() {
        setTimeout(function() {
            const { topOffset = 0, bottomOffset = 0 } = this.props;
            const { scrollHeight, scrollTop, clientHeight } = this.scrollContainer;

            let isSticky;

            if (scrollTop) {
                // TODO
                // 可滚动容器
                if (this.topSticky) {
                    const { top: curFromTop, bottom: curFromBottom } = this.content.getBoundingClientRect();
                    if (this.topSticky) {
                        isSticky = scrollTop > topOffset
                        // scrollHeight - scrollTop - clientHeight < topOffset
                    } else {
                    }
                } else {
                }
            } else {
                const { clientHeight: selfHeight } = this.content
                const { top: originFromTop, bottom: originFromBottom, left: originFromLeft, width: originWidth} = this.placeholder.getBoundingClientRect();
                if (this.topSticky) {
                    isSticky = originFromTop < (topOffset > 0 ? topOffset + selfHeight : topOffset); // 临界条件：0，不要带`=`
                } else {
                    isSticky = originFromBottom - (document.documentElement.clientHeight || document.body.clientHeight) > bottomOffset;
                }
            }
            // console.log('topSticky:' + !!this.topSticky, 'bottomSticky:' + !!this.bottomSticky)
            // console.log('offset', this.topSticky ? topOffset : bottomOffset)
            this._triggerHandler(isSticky);
        }.bind(this), 100);
    }
    _triggerHandler(isSticky) {
        const wasSticky = !!this.state.isSticky;
        if (isSticky === wasSticky) return

        let distance2Right = (document.documentElement.clientWidth || document.body.clientWidth) - this.state.originFromRight

        const style = !isSticky ? {} : {
            position: 'fixed', // 理论上是相对body固定定位
            zIndex: 101,
            left: this.state.originFromLeft,
            right: distance2Right >= 0 ? distance2Right : 0
            //width: originWidth // 依赖于`box-sizing: border-box`
        };

        if (isSticky && this.topSticky) {
            style.top = this.props.topOffset;
        } else if(isSticky) {
            style.bottom = this.props.bottomOffset;
        }

        this.setState({
            isSticky: isSticky,
            style: style
        });

        console.log('isSticky:' + isSticky)

        const {fixedHandler} = this.props;
        isSticky !== wasSticky && typeof fixedHandler == 'function' && fixedHandler(isSticky);
    }
    render() {
        /**
         * TODO: sticky无法触发其他事件，默认滚动触发，可选的sticky
         * WrappedComponent 必须显式使用`style`属性
         */
        return (
            <div>
                <WrappedComponent {...this.props} ref={content => this.content = ReactDOM.findDOMNode(content) } 
                    positionStyle={this.state.style} 
                    isSticky={this.state.isSticky}/>
                <div ref={ placeholder => this.placeholder = placeholder } />
            </div>
        );
    }
    noop() {}
}


// WEBPACK FOOTER //
// ./src/common/component/sticky/index.jsx